<div class="header-panel sticky">
  <span
    matTooltip="It is not possible to go back while the cm is running."
    [matTooltipDisabled]="!isCMRunning$()"
  >
    <button (click)="toggleCMPanel()" matIconButton aria-label="Back" [disabled]="isCMRunning$()">
      <mat-icon>arrow_back</mat-icon>
    </button>
  </span>
  <h2 class="cm_title">{{ cmSelected.cm_name }}</h2>
</div>

<div class="content-container">
  <div class="description">
    <p [innerHTML]="cmSelected.cm_description"></p>
    @if (cmSelected.wiki_url) {
      <a href="{{ cmSelected.wiki_url }}" target="_blank">
        <button matIconButton aria-label="CM wiki" matTooltip="CM wiki">
          <mat-icon>menu_book</mat-icon>
        </button>
      </a>
    }
  </div>

  <div class="session-box">
    <h3 class="input-prefix">
      <label for="session-name" class="input_title">Session name</label>
      <input
        id="session-name"
        class="uk-input"
        maxlength="50"
        type="text"
        placeholder="{{ defaultPrefix }}"
        [(ngModel)]="prefixSessionName"
      />
    </h3>
  </div>

  @let cmInputsState = cmInputsState$();
  @if (cmInputsState.status === 'loading') {
    <div class="spinner-container">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  } @else if (cmInputsState.status === 'error') {
    <p class="no-data">
      CM not available<br />
      Please, try again later.
    </p>
  } @else {
    @if (cmInputs$().length > 0) {
      <div class="session-box">
        <h3 for="session-name">Import CM inputs</h3>
        <app-import-cm-inputs (dataImported)="handleImportedData($event)"></app-import-cm-inputs>
      </div>
    }
    <mat-accordion [multi]="true">
      @for (inputCategory of inputsByCategories(); track $index) {
        @if (inputCategory.inputs.length > 0) {
          <mat-expansion-panel [expanded]="$index === 0 || $index === 5">
            <mat-expansion-panel-header>
              <mat-panel-title>{{ inputCategory.name }}</mat-panel-title>
            </mat-expansion-panel-header>
            @for (input of inputCategory.inputs; track $index) {
              @if (calculationModuleService.isDynamicCMInputArray(input)) {
                <app-dynamic-cm-inputs-array
                  [dynamicCMInputArray]="input"
                ></app-dynamic-cm-inputs-array>
              } @else if (calculationModuleService.isDynamicCMInputOptions(input)) {
                <app-dynamic-cm-inputs-options
                  [dynamicCMInputOptions]="input"
                ></app-dynamic-cm-inputs-options>
              } @else if (calculationModuleService.isCMLayerInput(input)) {
                <app-cm-input [cmInput]="input"></app-cm-input>
              } @else {
                <app-cm-input [cmInput]="input"></app-cm-input>
              }
            }
          </mat-expansion-panel>
        }
      }
    </mat-accordion>

    @if (!isCMRunning$()) {
      <span
        [matTooltip]="formatLevelAvailabilityToolTip(cmSelected)"
        [matTooltipDisabled]="!isRunCMDisabled(cmSelected)"
      >
        <button
          matButton="filled"
          class="main-button"
          (click)="runCM()"
          [disabled]="isRunCMDisabled(cmSelected)"
        >
          <mat-icon>play_arrow</mat-icon>Run CM
        </button></span
      >
    } @else {
      <button matButton="filled" class="main-button warn-button" (click)="stopCM()">
        <mat-icon><mat-spinner class="spinner-button" diameter="18"></mat-spinner></mat-icon>
        Stop CM
      </button>
    }
  }
</div>
